import api from "./api";

export const dashboardService = {
  getWidgetsOverview(params = {}) {
    return api.get("/dashboard/widgets/overview", { params });
  },
};
